import React from 'react';
import PropTypes from 'prop-types';
import getConfig from 'next/config';

const {
	publicRuntimeConfig: {
		services: { neb }
	}
} = getConfig();

const StyledContentNebBook = ({ bookId }) => {
	const { widgetUrl } = neb;
	const widgetSrc = `${widgetUrl}${bookId}?widget=1`;
	return (
		<iframe
			className="pvi-no-styles"
			title="NEB Book"
			src={widgetSrc}
			allowtransparency="true"
			width="100%"
			height="700px"
			style={{ border: 'none', overflow: 'hidden' }}
			allowFullScreen
		/>
	);
};

StyledContentNebBook.propTypes = {
	bookId: PropTypes.string.isRequired
};

export default StyledContentNebBook;
